import { endOfMonth, startOfMonth } from 'date-fns';

export const isOffRange = (eventDate: Date, date: Date) => {
  return eventDate! > endOfMonth(date) || eventDate! < startOfMonth(date);
};
